<script setup>
// 游戏画布由 App.vue 中常驻的 GameCanvasHost 承载。
// 这个 View 的职责仅仅是让 /game/:level 成为一个真正的 Vue Router 页面。
defineProps({ level: { type: Number, required: true } });
</script>

<template>
  <div class="game-route-placeholder" aria-hidden="true" />
</template>
